import { FC } from 'react'
import { SegmentedControl } from '@mantine/core'
import { useSelector } from 'react-redux'
import { getTypeRating } from '../../model/selectors/getTypeRating/getTypeRating'
import { useAppDispatch } from 'shared/hooks/useAppDispatch'
import { filterRatingActions } from '../../model/slices/FilterRatingSlice'
import { RatingType } from '../../model/types/filterRating'

export const FilterRating: FC = () => {
	const typeRating = useSelector(getTypeRating)
	const dispatch = useAppDispatch()
	const onChangeControl = (value: RatingType) => {
		dispatch(filterRatingActions.changeTypeReducer(value))
	}

	return (
		<SegmentedControl
			value={typeRating}
			onChange={onChangeControl}
			color={'blue'}
			data={[
				{ label: 'Общая таблица', value: 'general' },
				{ label: 'Личный рейтинг', value: 'personal' },
			]}
		/>
	)
}
